export const SectionHeading = ({ eyebrow, title, intro, align = 'center' }) => (
    <div className={`mb-10 max-w-3xl ${align === 'left' ? 'text-left' : 'mx-auto text-center'}`}>
        {eyebrow && <p className="section-eyebrow">{eyebrow}</p>}
        <h2 className="section-title">{title}</h2>
        {intro && <p className="section-intro">{intro}</p>}
    </div>
);

export const PageHero = ({ image, title, subtitle }) => (
    <div className="relative isolate overflow-hidden">
        <img src={image} alt="" className="page-hero-image" />
        <div className="page-hero-overlay" />
        <div className="page-hero-content">
            <p className="section-eyebrow text-white/80">Neuroptimisme</p>
            <h1 className="page-hero-title">{title}</h1>
            {subtitle && <p className="page-hero-subtitle">{subtitle}</p>}
        </div>
    </div>
);

export const Surface = ({ children, className = '' }) => (
    <div className={`surface ${className}`}>{children}</div>
);

export const SocialIcon = ({ href, label, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="social-icon">
        {children}
    </a>
);
